import { FULL_HD, HD, TRANSPARENT_IMAGE_FORMAT, RENDERING_CONTEXT } from '@bedrock-rdk/constants';

export * from './customer/default/cover.constants';

export const templates = {
  Cover: 'Cover',
};

export const sizes = {
  [templates.Cover]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: 136,
        h: 232,
      },
      [FULL_HD]: {
        w: 208,
        h: 336,
      },
    },
  },
};

const commonImageOptions = {
  format: TRANSPARENT_IMAGE_FORMAT,
  fit: 'scale_crop',
};

export const imageOptions = {
  [templates.Cover]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          ...commonImageOptions,
          width: 128,
          height: 128,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          ...commonImageOptions,
          width: 192,
          height: 192,
        },
      },
    },
  },
};
